import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchTips } from '@/services/tip';

export const getTips = createAsyncThunk('tip/fetchTips', fetchTips);

export const tipSlice = createSlice({
  name: 'tip',

  initialState: [],

  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getTips.fulfilled, (state, { payload }: any) => {
      if (!payload) {
        return [];
      }
      state = payload;
      return state;
    });
  },
});

export const { } = tipSlice.actions;

export default tipSlice.reducer;
